import { GoogleAnalyticsState } from '../../features/config';

export const hasOptionalCookies = (googleAnalytics: GoogleAnalyticsState): boolean => googleAnalytics.enabled;
